<template>
  <div class="device-check-dialog">
    <div class="mask"></div>
    <div class="comp-container__platform-check">
      <div class="title">设备检测</div>
      <div class="check-container">
        <div class="check-item camera-box" v-if="roomInfo.mode != 1">
          <div class="check-item__title">摄像头</div>
          <div class="check-item__content">
            <el-select
              v-model="camera"
              placeholder="请选择"
              popper-class="device-check-popper"
              class="live-room-el-select"
              @change="changeCamera"
              :disabled="
                (userStatus.is_up_stage !== 1 ||
                  userStatus.is_send_video !== 1) &&
                type !== 'init'
              "
            >
              <el-option
                v-for="item in cameraOptions"
                :key="item.deviceId"
                :label="item.deviceName"
                :value="item.deviceId"
              >
              </el-option>
            </el-select>
            <div class="camera-preview-box">
              <div
                class="camera-preview"
                v-show="deviceSwtich.camera === 'on'"
                ref="cameraPreview"
              ></div>
              <div class="camera-default" v-if="deviceSwtich.camera === 'off'">
                <img :src="userInfo.avatar" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="check-item micro-box">
          <div class="check-item__title">麦克风</div>
          <div class="check-item__content">
            <el-select
              v-model="micro"
              placeholder="请选择"
              popper-class="device-check-popper"
              @change="changeMicro"
              class="live-room-el-select"
              :disabled="
                (userStatus.is_up_stage !== 1 ||
                  userStatus.is_send_audio !== 1) &&
                type !== 'init'
              "
            >
              <el-option
                v-for="item in microphoneOptions"
                :key="item.deviceId"
                :label="item.deviceName"
                :value="item.deviceId"
              >
              </el-option>
            </el-select>
            <div class="test-volume">
              <img src="../../../assets/images/live/audio-icon.png" alt="" />
              <volume-test
                class="test-volume-box"
                :volume="microTestVolume"
                :boxCount="11"
              ></volume-test>
            </div>
          </div>
        </div>
        <div class="check-item speaker-box">
          <div class="check-item__title">扬声器</div>
          <div class="check-item__content">
            <div class="select-box">
              <el-select
                v-model="speaker"
                placeholder="请选择"
                popper-class="device-check-popper"
                @change="changeSpeaker"
                class="live-room-el-select"
              >
                <el-option
                  v-for="item in speakerOptions"
                  :key="item.deviceId"
                  :label="item.deviceName"
                  :value="item.deviceId"
                >
                </el-option>
              </el-select>
              <el-button
                @click="onClickCheckSpeaker"
                class="check-btn__speaker"
                :class="{ 'check-btn__speaker--play': speakerPlaying }"
              >
                <img
                  v-if="!speakerPlaying"
                  src="@saas/pages/assets/images/live/speaker-1.png"
                  alt=""
                />
                <img
                  v-else
                  src="@saas/pages/assets/images/live/speaker.gif"
                  alt=""
                />
                检测
              </el-button>
            </div>
            <div class="test-volume test-volume-speaker">
              <img src="@saas/pages/assets/images/live/speaker.png" alt="" />
              <el-slider
                class="slider-box"
                v-model="speakerVolume"
                @input="inputSpeakerVolume"
                @change="changeSpeakerVolume"
              ></el-slider>
              <div class="speaker-tips-box">
                <el-popover
                  placement="bottom"
                  popper-class="speaker-volume-tips-popover"
                  :append-to-body="false"
                  trigger="manual"
                  v-model="speakerPopoverVisible"
                  content="扬声器音量较低，你可能无法听到教室内的声音，建议调大音量"
                >
                  <el-button
                    class="speaker-tips-button"
                    slot="reference"
                  ></el-button>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
        <div
          class="check-item screen-box"
          v-if="isElectron && isMac && roomInfo.mode != 1"
        >
          <div class="check-item__title">屏幕共享</div>
          <div class="check-item__content">
            <div class="permission-content">
              <div
                class="permission-result"
                :class="{ 'permission-error': !screenCapturePermsiion }"
              >
                <div class="permission-text">
                  {{
                    screenCapturePermsiion ? "正常" : "异常，暂无屏幕分享权限"
                  }}
                </div>
                <img
                  v-if="screenCapturePermsiion"
                  src="@saas/pages/assets/images/live/success.png"
                  alt=""
                />
                <img
                  v-else
                  src="@saas/pages/assets/images/live/error.png"
                  alt=""
                />
              </div>
              <el-button
                v-if="!screenCapturePermsiion"
                @click="onClickSetCapturePermissions"
                class="check-btn__speaker"
              >
                去设置
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <template v-if="type === 'init'">
          <el-button @click="handleClose">退出</el-button>
          <el-button type="primary" @click="handleEnterRoom">进入</el-button>
        </template>
        <template v-else-if="type === 'handle'">
          <el-button type="primary" @click="handleConfirm">确定</el-button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import createTrtc from "../mixins/create-trtc.js";
import VolumeTest from "./VolumeTest.vue";
import { mapMutations, mapState } from "vuex";
import { closeWindow } from "@saas/components/src/utils/utils";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import testClient from "../mixins/test-client.js";
const isMac = () => {
  return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
};
export default {
  mixins: [createTrtc, testClient],
  props: {
    lessonId: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: "init",
    },
  },
  components: {
    VolumeTest,
  },
  data() {
    return {
      camera: null,
      micro: null,
      speaker: null,
      microTestVolume: 0,
      isElectron: window.isElectron,
      testSpeakerAudio: null,
      speakerPopoverVisible: false,
      timeout: null,
      speakerPlaying: false,
      screenCapturePermsiion: false,
      micTimer: null,
      isMac: isMac(),
    };
  },
  computed: {
    ...mapState("live", [
      "roomInfo",
      "liveService",
      "cameraList",
      "microphoneList",
      "speakerList",
      "signConfig",
      "deviceSwtich",
      "videoPermission",
      "audioPermission",
      "userStatus",
    ]),
    userInfo() {
      return this.$store.getters.user || {};
    },
    cameraOptions() {
      return [...this.cameraList, { deviceId: "disabled", deviceName: "禁用" }];
    },
    microphoneOptions() {
      return [
        ...this.microphoneList,
        { deviceId: "disabled", deviceName: "禁用" },
      ];
    },
    speakerOptions() {
      return [...this.speakerList];
    },
    speakerVolume: {
      get() {
        return this.$store.state.live.speakerVolume;
      },
      set(val) {
        this.setSpeakerVolume(val);
      },
    },
  },
  watch: {
    camera: {
      handler(val) {
        if (val) {
          if (val !== "disabled") {
            this.setDeviceSwtich({
              camera: "on",
            });
            this.handleSetCurrentCameraDeviceByTestClient({
              deviceId: val,
            }).then(() => {
              this.$nextTick(() => {
                if (this.roomInfo.mode !== 1) {
                  this.handleStartLocalPreviewByTestClient({
                    dom: this.$refs.cameraPreview,
                  });
                }
              });
            });
          } else {
            this.handleStopLocalPreviewByTestClient();
            this.setDeviceSwtich({
              camera: "off",
            });
          }
        }
      },
      immediate: true,
    },
    cameraList: {
      handler(val) {
        console.log("cameraList___", val);
        console.log(
          "cameraList___this.deviceSwtich.camera",
          this.deviceSwtich.camera
        );
        if (!this.videoPermission) {
          this.camera = "disabled";
          return;
        }
        if (this.type === "handle" && this.deviceSwtich.camera === "off") {
          this.camera = "disabled";
          return;
        }
        if (val && val.length) {
          let currentCamera = this.liveService.getCurrentCameraDevice();
          console.log("currentCamera___", currentCamera);
          if (!currentCamera) {
            currentCamera = val[0];
          }
          this.camera = currentCamera.deviceId;
        } else {
          this.camera = "disabled";
        }
      },
      immediate: true,
    },
    microphoneList: {
      handler(val) {
        if (!this.audioPermission) {
          this.micro = "disabled";
          this.setDeviceSwtich({
            microphone: "off",
          });
          return;
        }
        if (this.type === "handle" && this.deviceSwtich.microphone === "off") {
          this.micro = "disabled";
          return;
        }
        if (val) {
          if (val.length) {
            let device = null;
            if (this.type === "init") {
              device = val.find((item) => item.isDefault);
              console.log("defaultDevice___", device);
              if (this.checkMicIsVirtual(device)) {
                device = val.find((item) => !this.checkMicIsVirtual(item));
              }
            } else {
              device = this.liveService.getCurrentMicDevice();
            }
            if (device) {
              this.micro = device.deviceId;
              this.setCurrentMicDevice(device);
            } else {
              this.micro = val[0].deviceId;
              this.setCurrentMicDevice(val[0]);
            }
            this.liveService.on("testMicVolume", (volume) => {
              // console.log("==99testMicVolume>>>>", volume);
              this.microTestVolume = volume;
              clearTimeout(this.micTimer);
              this.micTimer = setTimeout(() => {
                this.microTestVolume = 0;
              }, 100);
            });
            // this.liveService.startLocalAudio();
            this.updateMicDeviceTest(true);
            this.setDeviceSwtich({
              microphone: "on",
            });
          } else {
            this.micro = "disabled";
            this.setDeviceSwtich({
              microphone: "off",
            });
          }
        }
      },
      immediate: true,
    },
    speakerList: {
      handler(val) {
        if (val && val.length) {
          let device = null;
          if (this.type === "init") {
            device = val.find((item) => item.isDefault);
            if (this.checkSpeakerIsVirtual(device)) {
              device = val.find((item) => !this.checkSpeakerIsVirtual(item));
            }
          } else {
            device = this.liveService.getCurrentSpeakerDevice();
          }
          if (device) {
            this.speaker = device.deviceId;
            this.setCurrentSpeakerDevice(device);
          } else {
            this.speaker = val[0].deviceId;
            this.setCurrentSpeakerDevice(val[0]);
          }
          this.setSpeak();
        }
      },
      immediate: true,
    },
    signConfig: {
      handler(val) {
        console.log("signConfig", val);
        if (val.user_id && this.type === "init") {
          this.createTrtc();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  beforeDestroy() {
    this.testSpeakerAudio.removeEventListener(
      "ended",
      this.onTestSpeakerAudioEnd
    );
    this.updateMicDeviceTest(false);
    this.testSpeakerAudio.pause();
    this.testSpeakerAudio = null;
    this.handleStopLocalPreviewByTestClient();
  },
  mounted() {
    this.initSpeakerAudio();
    if (this.isElectron) {
      this.checkScreenSharePermission();
    }
    this.setSpeak();
  },
  methods: {
    ...mapMutations("live", [
      "setCurrentCameraDevice",
      "setCurrentMicDevice",
      "setCurrentSpeakerDevice",
      "setDeviceSwtich",
      "setSpeakerVolume",
      "setShowDeviceCheck",
    ]),
    initSpeakerAudio() {
      this.testSpeakerAudio = document.createElement("audio");
      this.testSpeakerAudio.src =
        process.env.VUE_APP_CDN_URL + "/cdn/static/audio/testspeak.mp3";
      this.testSpeakerAudio.addEventListener(
        "ended",
        this.onTestSpeakerAudioEnd
      );
    },
    // isMac() {
    //   console.log(window.navigator.platform.toUpperCase().indexOf("MAC") >= 0);
    //   return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    // },
    handleEnterRoom() {
      uploadLiveLog({
        message: "用户点击设备检查进入房间",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_enter_room",
          camera: this.camera,
          micro: this.micro,
          type: this.type,
        },
      });
      this.setCurrentMicDevice({
        deviceId: this.micro,
      });
      this.setCurrentCameraDevice({
        deviceId: this.camera,
      });
      this.setCurrentSpeakerDevice({
        deviceId: this.speaker,
      });
      this.handleStopLocalPreviewByTestClient();
      if (!window.isElectron) {
        if (this.userStatus.is_up_stage !== 1) {
          this.liveService.client.stopLocalVideo();
        }
      }
      this.$emit("enterRoom", {
        camera: this.camera,
        micro: this.micro,
      });
    },
    handleConfirm() {
      uploadLiveLog({
        message: "用户点击设备检查确定按钮",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_confirm",
          type: this.type,
        },
      });
      this.setCurrentMicDevice({
        deviceId: this.micro,
      });
      this.setCurrentCameraDevice({
        deviceId: this.camera,
      });
      this.setCurrentSpeakerDevice({
        deviceId: this.speaker,
      });
      this.handleStopLocalPreviewByTestClient();
      this.setShowDeviceCheck({
        visible: false,
      });
    },
    handleClose() {
      uploadLiveLog({
        message: "用户点击设备检查退出按钮",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_close",
          type: this.type,
        },
      });
      if (this.isElectron) {
        window.LiveElectronApi.closeWin();
      } else {
        closeWindow();
      }
    },
    // 切换摄像头
    changeCamera(device) {
      uploadLiveLog({
        message: "用户点击设备检查切换摄像头",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_change_camera",
          deviceId: device,
          type: this.type,
        },
      });
    },
    // 切换麦克风
    changeMicro(device) {
      uploadLiveLog({
        message: "用户点击设备检查切换麦克风",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_change_micro",
          deviceId: device,
          type: this.type,
        },
      });

      const deviceInfo = this.microphoneOptions.find(
        (item) => item.deviceId === device
      );
      this.setCurrentMicDevice(deviceInfo);
      if (device === "disabled") {
        this.liveService.muteLocalAudio({ mute: true });
        this.updateMicDeviceTest(false);
        this.setDeviceSwtich({
          microphone: "off",
        });
      } else {
        // this.liveService.setCurrentMicDevice({ deviceId: device });
        this.updateMicDeviceTest(true);
        this.liveService.muteLocalAudio({ mute: false });
        this.setDeviceSwtich({
          microphone: "on",
        });
      }
    },
    updateMicDeviceTest(tag) {
      if (tag) {
        this.liveService.startMicDeviceTest({
          interval: 100,
          playback: false,
        });
      } else {
        this.microTestVolume = 0;
        this.liveService.stopMicDeviceTest();
      }
    },
    // 切换扬声器
    changeSpeaker(device) {
      uploadLiveLog({
        message: "用户点击设备检查切换扬声器",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_change_speaker",
          deviceId: device,
          type: this.type,
        },
      });

      const deviceInfo = this.speakerOptions.find(
        (item) => item.deviceId === device
      );
      this.setCurrentSpeakerDevice(deviceInfo);
      if (device === "disabled") {
        this.setDeviceSwtich({
          speaker: "off",
        });
      } else {
        this.liveService.setCurrentSpeakerDevice({ deviceId: device });
        this.setDeviceSwtich({
          speaker: "on",
        });
        // 关键：设置测试音频的输出设备
        this.setSpeak();
      }
    },
    inputSpeakerVolume(val) {
      if (this.testSpeakerAudio) {
        this.testSpeakerAudio.volume = val / 100;
      }
    },
    changeSpeakerVolume(val) {
      if (val <= 10) {
        this.speakerPopoverVisible = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.speakerPopoverVisible = false;
        }, 5000);
      } else {
        this.speakerPopoverVisible = false;
      }
      // 扬声器音量只控制系统扬声器，不影响 TRTC 远端音频
    },
    onClickCheckSpeaker() {
      uploadLiveLog({
        message: "用户点击设备检查测试扬声器",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_test_speaker",
          type: this.type,
        },
      });

      this.speakerPlaying = true;
      // 检测扬声器
      this.testSpeakerAudio.play();
    },
    async checkScreenSharePermission() {
      console.log("教研权限");

      this.screenCapturePermsiion = await window.ipcRenderer.invoke(
        "getMediaAccessStatus",
        {
          mediaType: "screen",
        }
      );
    },
    onClickSetCapturePermissions() {
      uploadLiveLog({
        message: "用户点击设备检查设置分享权限",
        extra: {
          component: "DeviceCheck",
          action: "click_device_check_set_permissions",
          type: this.type,
        },
      });

      window.ipcRenderer.send("open-permission-setting", {
        curtMediaType: "screen",
      });
    },
    // 获取可分享的屏幕
    getScreenCaptureSources() {
      this.shareWinList = this.liveService.getScreenCaptureSources({
        thumbHeight: 320,
        thumbWidth: 180,
        iconHeight: 32,
        iconWidth: 32,
      });
      console.log("shareWinList>>>", this.shareWinList);
    },
    setSpeak() {
      const deviceInfo = this.speakerOptions.find(
        (item) => item.deviceId === this.speaker
      );
      if (deviceInfo) {
        // 关键：设置测试音频的输出设备
        if (
          this.testSpeakerAudio &&
          typeof this.testSpeakerAudio.setSinkId === "function"
        ) {
          this.testSpeakerAudio
            .setSinkId(deviceInfo.realDeviceId || deviceInfo.deviceId)
            .catch((err) => {
              console.warn("setSinkId failed", err);
            });
        }
      }
    },
    onTestSpeakerAudioEnd() {
      this.speakerPlaying = false;
    },
    // 校验麦克风是否是虚拟麦克风
    checkMicIsVirtual(mic = {}) {
      return mic.deviceName?.toLowerCase().includes("virtual") || false;
    },
    // 校验扬声器是否是虚拟扬声器
    checkSpeakerIsVirtual(speaker = {}) {
      return speaker.deviceName?.toLowerCase().includes("virtual") || false;
    },
  },
};
</script>

<style scoped lang="scss">
.device-check-dialog {
  position: fixed;
  z-index: 1999;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .mask {
    width: 100%;
    height: 100%;
    backdrop-filter: blur(7px);
    /* 设置高斯模糊效果 */
    background-color: rgba(0, 0, 0, 0.2);
    /* 背景颜色 */
  }

  .comp-container__platform-check {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
}
.comp-container__platform-check {
  width: 449px;
  // height: 798px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 20px 16px 16px 16px;
  .title {
    font-size: 18px;
    color: #ffffff;
    line-height: 28px;
    font-weight: 500;
  }
  .check-container {
    margin-top: 14px;
    .check-item {
      position: relative;
      margin-bottom: 24px;
      .check-item__title {
        font-weight: 500;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        margin-bottom: 4px;
      }
    }
    .camera-box,
    .micro-box,
    .speaker-box {
      .camera-preview-box {
        position: relative;
        width: 100%;
        height: 235px;
        background: #27272a;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px 12px 12px 12px;
        overflow: hidden;
        .camera-default {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #27272a;
          img {
            width: 93px;
            height: 93px;
            border-radius: 50%;
          }
        }
        .camera-preview {
          width: 100%;
          height: 100%;
        }
      }

      .test-volume {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
        }
        .el-progress {
          flex: 1;
          margin-left: 11px;
        }
        .test-volume-box {
          flex: 1;
          margin-left: 11px;
        }
        .el-slider {
          flex: 1;
          margin-left: 11px;
        }
      }
      .el-select ::v-deep {
        width: 100%;
        margin-bottom: 8px;
        background: #27272a;
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
        border-radius: 12px 12px 12px 12px;
        &:hover {
          background: #3f3f46;
          .el-input__inner {
            background: #3f3f46;
          }
        }
        .el-input__inner {
          background: #27272a;
          border: none;
          color: #c9cdd4;
        }
      }
      .select-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-select {
          margin: 0;
        }
        .check-btn__speaker ::v-deep {
          width: 90px;
          height: 40px;
          background: #18181b;
          border: 1px solid rgba(63, 63, 70, 0.4);
          border-radius: 12px 12px 12px 12px;
          margin-left: 12px;
          color: #ffffff;
          font-size: 14px;
          color: #e8f3ff;
          padding: 0;
          span {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            img {
              width: 24px;
              height: 24px;
              margin-right: 6px;
            }
          }

          &:hover {
            background: #0e42d2;
          }
        }
        .check-btn__speaker--play {
          background: #0e42d2;
        }
      }
      .slider-box ::v-deep {
        flex: 1;
        .el-slider__runway {
          background: #52525b;
          height: 8px;
        }
        .el-slider__bar {
          background: #165dff;
          height: 8px;
        }
        .el-slider__button-wrapper {
          .el-slider__button {
            width: 18px;
            height: 18px;
            background: #18181b;
            border: 2px solid #165dff;
          }
        }
      }
    }
    .screen-box {
      .permission-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .permission-result {
          padding: 0 12px;
          font-weight: 500;
          font-size: 14px;
          color: #c9cdd4;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          min-width: 331px;
          flex: 1;
          height: 40px;
          background: #27272a;
          box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
          border-radius: 12px 12px 12px 12px;
          border: 1px solid #27272a;
        }
        .permission-error {
          border: 1px solid #f76560;
        }
        img {
          width: 24px;
          height: 24px;
        }
      }
      .el-button {
        width: 74px;
        height: 40px;
        background: #18181b;
        border: 1px solid rgba(63, 63, 70, 0.4);
        border-radius: 12px 12px 12px 12px;
        margin-left: 12px;
        color: #ffffff;
        font-size: 14px;
        color: #e8f3ff;
        padding: 0;
      }
    }
  }
  .footer {
    display: flex;

    justify-content: space-between;
    align-items: center;
    .el-button {
      // flex: 1;
      // height: 40px;
      // background: rgba(63, 63, 70, 0.4);
      // border-radius: 12px 12px 12px 12px;
      // font-size: 14px;
      // color: #ecedee;
      // border: none;
    }
    .el-button {
      flex: 1;
      background: #165dff;
      border-radius: 12px 12px 12px 12px;
      border: none;
      font-weight: 500;
      font-size: 14px;
      color: #ecedee;
      &.el-button--primary {
        background: #165dff;
        &:hover {
          background: #165dff !important;
        }
        &:focus {
          background: #165dff !important;
        }
      }
      &.el-button--default {
        background: #3f3f46;
      }
    }
  }
}
.test-volume-speaker {
  position: relative;
  .speaker-tips-box {
    position: absolute;
    left: 73px;
    top: 16px;
    .speaker-tips-button {
      // width: 100px;
      width: 10px;
      height: 0;
      padding: 0;
      border: none;
      background: transparent;
    }
  }
}
</style>
<style lang="scss">
.device-check-popper {
  position: fixed;
  z-index: 999999999 !important;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 0 16px;
  margin-top: 6px !important;
  .el-select-dropdown__list {
    padding: 0;
  }
  .el-select-dropdown__item {
    color: #c9cdd4;
    border-bottom: 1px solid #27272a;
    padding: 0;
    height: 44px;
    display: flex;
    align-items: center;
    align-items: center;
    &:last-child {
      border-bottom: none;
    }
    &.selected {
      background: #18181b;
      color: #4080ff;
    }
    &.hover {
      background: transparent;
    }
  }
  .popper__arrow {
    display: none;
  }
}

.speaker-volume-tips-popover {
  width: 213px;
  position: absolute !important;
  background: #27272a;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-color: #27272a;
  padding: 12px;
  font-size: 12px;
  color: #c9cdd4;
  line-height: 16px;
  .popper__arrow {
    border-bottom-color: #27272a !important;
    &::after {
      border-bottom-color: #27272a !important;
    }
  }
}
</style>
